// ADD NEW ADDRESS JS FUNCTIONALITY ---------------------------------------

const body = document.querySelector(" body ");
const addTrigger = document.querySelector(" .add-address-btn ");
const addForm = document.querySelector(" #AddAddress.add-address-wrapper");
const cancelTrigger = document.querySelector(" .cancel-add-address ");



// console.log(addTrigger);
// console.log(addForm);
// if (addTrigger && addForm) {
//   // Open New Address Form
//   addTrigger.addEventListener("click", (e) => {
//       console.log('add address')
//     if (addForm.classList.contains("active")) {
//       return;
//     } else {
//       addForm.classList.add("active");
//       addTrigger.classList.add("active");
//     }
//   });
// }

// if (cancelTrigger && addForm && addTrigger) {
//   // Close New Address Form
//   cancelTrigger.addEventListener("click", (e) => {
//     if (addForm.classList.contains("active")) {
//       addForm.classList.remove("active");
//       addTrigger.classList.remove("active");
//     } else {
//       return;
//     }
//   });
// }

//-------------------------------------------------------------------------

// EDIT ADDRESS JS FUNCTIONALITY ------------------------------------------

const editTrigger = document.querySelectorAll(" .edit-address-trigger ");

if (editTrigger) {
  // Close Edit Address Form
  editTrigger.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // console.log( 'Edit Button', btn.closest('.address-card').querySelector('.edit-mask') );
      // console.log( 'Edit Button Closest: ', btn.closest('.address-card') );
      body.classList.add("locked");
      btn
        .closest(".address-card")
        .querySelector(".edit-mask")
        .classList.add("active");
    });
  });
}

const cancelEdit = document.querySelectorAll(" .cancel-edit-btn ");

if (cancelEdit) {
  // Close Edit Address Form
  cancelEdit.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      // console.log('Cancel Button Clicked:', btn.closest('.edit-mask') )
      body.classList.remove("locked");
      btn.closest(".edit-mask").classList.remove("active");
    });
  });
}


// new functionality
function InitAddressForms() {
  // update address countries
  const Addressforms = document.querySelectorAll('.address-form');

  Addressforms.forEach((form) => {
    const countrySelect = form.querySelector('[data-address-country-select]');

    countrySelect.addEventListener('change', (e) => {
      const selectedCountry = e.target.options[e.target.selectedIndex];
      const provinces = selectedCountry.getAttribute('data-provinces');

      updateProvinceSelector(form, provinces);
    });

    if (countrySelect) {
      const value = countrySelect.getAttribute('value');

      if (value) {
        const option = countrySelect.querySelector(`option[value="${value}"]`);
        if (option) {
          option.setAttribute('selected', 'selected');
          const provinces = option.getAttribute('data-provinces');

          updateProvinceSelector(form, provinces);
        }
      }
    }
  });
}
function updateProvinceSelector(form, provinces) {
  const provinceWrapper = form.querySelector('.province-input');
  const provincesSelect = provinceWrapper.querySelector('select');

  if (!provinces || provinces == '[]') {
    provinceWrapper.style.display = 'none';
    provincesSelect.setAttribute("aria-hidden", true)
    return;
  }

  provincesSelect.innerHTML = '';

  if (provinces) {
    const provincesJSON = JSON.parse(provinces);

    if (provincesSelect) {
      provincesJSON.forEach((province) => {
        let option = document.createElement('option');
        option.value = province[0];
        option.innerText = province[0];

        provincesSelect.appendChild(option);
      });
    }
    provinceWrapper.style.display = 'block';
    provincesSelect.setAttribute("aria-hidden", false)

  }
}

function InitDeleteAddress() {
  const addressWrapper = document.querySelector('.address-wrapper');

  if(!addressWrapper) return;

  addressWrapper.addEventListener('click', (e) => {
    const deleteBtn = e.target.closest('.address-delete-form');

    if (deleteBtn) {
      e.preventDefault();

      const onComplete = () => {
        const url = deleteBtn.getAttribute('action');
        const data = new FormData();
        data.set('_method', 'delete');
        axios.post(url, data).then(() => {
          location.reload();
        });
      };

      window.modalController.presentModal('delete-address', 0, onComplete);
    }
  });

}

  InitAddressForms()
  InitDeleteAddress()